import { Divider, styled } from '@mui/material'

export const Separador = styled(Divider)({
  margin: '1rem 0 1.75rem 0',
  opacity: '.5'
})
